<template>

<com-logic>

    <com-operand :type="type" :rule="rule" :options="options" v-model="model.operand" />

    <portal to="after">

        <com-input :type="type" :rule="rule" v-model="model.value" />

    </portal>

    <com-input force="numeric" :type="type" :rule="rule" v-model="model.tolerance" />

    <div class="logic-text">{{ plural }} from this set</div>

</com-logic>

</template>

<script>

import mixLogic from './logic'

export default {

    mixins: [mixLogic],

    data: function() {
        
        return {
            model: {
                operand: '>=',
                value: '',
                tolerance: 2
            },
            options: [
                '=',
                '!=',
                '>=',
                '>',
                '<=',
                '<'
            ]
        }
        
    },

    computed: {

        plural: function() {

            var unit = this.unit

            if(this.model.tolerance !== 1) {

                var lastLetter = this.unit[this.unit.length - 1]

                if (lastLetter === 'y') {

                    unit = unit.replace('y', 'ies')

                } else if (lastLetter === 's') {

                    unit = unit + 'es'

                } else {

                    unit = unit + 's'

                }

            }

            return unit

        }

    }

}

</script>

<style scoped>

</style>